
export type CopTokenAuthConfig = {
  apiBaseUrl: string
  clientId: string
  tenantId: string
  backendAppId: string
  authorityHost: string
  loginHint?: string
  cookieExpiryName: string
  powerPortalFlagCookieName: string
  cookiePath: string
  cookieSameSite: 'Strict' | 'Lax' | 'None'
  cookieSecure: boolean
  eventName: string
  debug: boolean
  redirectPath: string
  iframeTimeoutMs: number
  cacheLocation: 'localStorage' | 'sessionStorage'
  allowedOrigins: string[]
  logoutPath: string
}

const CONFIG: CopTokenAuthConfig = {
  apiBaseUrl: '',
  clientId: '',
  tenantId: '',
  backendAppId: '',
  authorityHost: '',
  cookieExpiryName: 'cop_token_expiry',
  powerPortalFlagCookieName: 'cop_powerportal_flag',
  cookiePath: '/',
  cookieSameSite: 'Lax',
  cookieSecure: true,
  eventName: 'cop:token-acquired',
  debug: true,
  redirectPath: '/saml-test',
  iframeTimeoutMs: 10000,
  cacheLocation: 'localStorage',
  allowedOrigins: [],
  logoutPath: '/system/sling/logout',
}

declare global {
  interface Window {
    __COP_LOGINAPP_CONFIG__?: Partial<CopTokenAuthConfig>
  }
}

const META_INTERIM_PAGE_PATH = 'meta[name="cop-interim-path"]'

// Authored page property (copInterimPagePath) overrides the default OAuth redirect/callback path.
const readInterimPagePath = (): string | null => {
  if (typeof document === 'undefined') return null
  const content = document.querySelector(META_INTERIM_PAGE_PATH)?.getAttribute('content')
  return content?.trim() || null
}

export const getCopTokenAuthConfig = (): CopTokenAuthConfig => {
  const injected = (typeof window !== 'undefined' && window.__COP_LOGINAPP_CONFIG__) || {}
  const interimPagePath = readInterimPagePath()
  return {
    ...CONFIG,
    ...injected,
    ...(interimPagePath ? { redirectPath: interimPagePath } : {}),
  }
}

export const getConfigSource = (): 'window.__COP_LOGINAPP_CONFIG__' | 'runtime config missing' => {
  if (typeof window === 'undefined') {
    return 'runtime config missing'
  }

  return window.__COP_LOGINAPP_CONFIG__?.clientId ? 'window.__COP_LOGINAPP_CONFIG__' : 'runtime config missing'
}